import { render, staticRenderFns } from "./AutomationActionTeamMessageInput.vue?vue&type=template&id=0243b876&scoped=true&"
import script from "./AutomationActionTeamMessageInput.vue?vue&type=script&lang=js&"
export * from "./AutomationActionTeamMessageInput.vue?vue&type=script&lang=js&"
import style0 from "./AutomationActionTeamMessageInput.vue?vue&type=style&index=0&id=0243b876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0243b876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0243b876')) {
      api.createRecord('0243b876', component.options)
    } else {
      api.reload('0243b876', component.options)
    }
    module.hot.accept("./AutomationActionTeamMessageInput.vue?vue&type=template&id=0243b876&scoped=true&", function () {
      api.rerender('0243b876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/AutomationActionTeamMessageInput.vue"
export default component.exports